<template>
  <anchor
    :action="action"
    :category="category"
    :label="label"
    :href="url || href"
    :useVueRouter="useVueRouter"
    :button="true"
  >
    <icon v-if="iconLeft" :name="iconLeft" color="white" class="icon--left" />
    <span v-html="name" />
    <icon v-if="icon" :name="icon" color="white" class="margin-left-1x" />
  </anchor>
</template>

<script>
export default {
  props: {
    action: {
      type: String,
      default: 'click'
    },
    category: {
      type: String,
      default: 'link'
    },
    href: {
      type: String
    },
    label: {
      type: String
    },
    url: {
      type: String
    },
    icon: {
      type: String
    },
    iconLeft: {
      type: String
    },
    name: {
      type: String
    },
    useVueRouter: {
      type: Boolean,
      default: false
    }
  }
}
</script>
